import _ from 'lodash';
import React, {Component} from 'react';
import {formatPointValue} from '../utils/point_utils';
import {toCardinalAndArrow} from '../utils/wind_utils';
import './PointDetails.css';

class PointExtendedDetails extends Component {

  componentDidMount() {
    const onMount = this.props.onMount;
    if (onMount) {
      onMount();
    }
  }

  formatValue(value, meta_data) {
    let formatted = formatPointValue(value,
      meta_data.prefix,
      meta_data.units,
      meta_data.rounding_rule,
      meta_data.null_value,
      meta_data.value_names);
    if (meta_data.units === 'kts') {
      formatted += ` ( ${parseFloat(value).toFixed(meta_data.rounding_rule || 0)} kts )`;
    } else if (meta_data.units === '°' && meta_data.prefix.match(/wind/i)) {
      formatted += ` ( ${toCardinalAndArrow(value)} )`;
    }
    return formatted;
  }

  render() {
    const { popup_data } = this.props;
    let extendedData = null;
    if (popup_data.extended_data) {
      const sortedData = _.sortBy(popup_data.extended_data,
        ['indicator.group', 'indicator.menu_order_override', 'indicator.displayName']);
      extendedData = <React.Fragment>
        {sortedData
        .filter(data => !data.indicator.hide)
        .map((data, i) =>
          <div className="extended" key={'point-extended-details-' + i}>
            <div className="emphasis">{data.indicator.displayName}</div>
            <div className="indicator-value">{this.formatValue(data.value, data.indicator)}
            </div>
          </div>
        )}
      </React.Fragment>;
    }

    return extendedData;
  }
}

export default PointExtendedDetails;




// WEBPACK FOOTER //
// ./src/containers/PointExtendedDetails.js